var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.47 24.4554L11.4709 24.4543C12.648 22.9811 14.5847 20.4524 16.2296 17.7841C17.052 16.4501 17.8074 15.0717 18.3586 13.7661C18.9063 12.4687 19.2698 11.2031 19.2698 10.1063C19.2698 4.98523 15.1166 0.833984 9.99746 0.833984C4.87641 0.833984 0.725098 4.9853 0.725098 10.1063C0.725098 11.2024 1.08564 12.4675 1.63015 13.7651C2.17807 15.0708 2.92959 16.4493 3.7495 17.7835C5.38913 20.4517 7.32577 22.9805 8.52593 24.4566C9.2883 25.4034 10.7082 25.403 11.47 24.4554ZM12.4216 10.1063C12.4216 11.443 11.3342 12.5305 9.99746 12.5305C8.66077 12.5305 7.57334 11.443 7.57334 10.1063C7.57334 8.76965 8.66077 7.68223 9.99746 7.68223C11.3342 7.68223 12.4216 8.76965 12.4216 10.1063Z",
    fill: "#FF6700",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinOrange);
export default __webpack_public_path__ + "static/media/pin_orange.41c01926.svg";
export { ForwardRef as ReactComponent };